// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"08927954","499":"e7c98c4d","699":"e5620bf0","764":"9ff8f35c","812":"91ff0a1b","888":"aae578b8","924":"9795db07"}[chunkId] + ".chunk.css";
};